export default function TopicsSection() {
  const topics = [
    { label: '4K超清', hot: true },
    { label: '国产剧', hot: true },
    { label: '科幻电影', hot: true },
    { label: '免费在线', hot: false },
    { label: '综艺节目', hot: true },
    { label: '悬疑推理', hot: false },
    { label: '香蕉视频', hot: true },
    { label: '红桃视频', hot: false },
    { label: '91视频', hot: false },
    { label: '蜜桃视频', hot: false },
    { label: '暑期档', hot: true },
  ];

  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 mb-3 whitespace-nowrap">
              大家都在看
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              话题标签
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              当前热门搜索和关注主题，快速了解社区动态
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((topic) => (
              <a
                key={topic.label}
                href="#index"
                className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer no-underline whitespace-nowrap ${
                  topic.hot
                    ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-300'
                }`}
              >
                {topic.label}
                {topic.hot && (
                  <i className="ri-fire-line text-xs"></i>
                )}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}